import 'whatwg-fetch';
import config from '../../config/config';


const {
    API_PRODUCTS_URL,
    API_PRODUCT_URL,
    API_RELATED_PRODUCTS_URL,
} = config;

const consumerKey = process.env.REACT_APP_API_CONSUMER_KEY;
const consumerSecret = process.env.REACT_APP_API_CONSUMER_SECRET;

export const productsApi = {
    fetchList: async (params = {}, ) => {
        const queryParams = new URLSearchParams({
            page: 1,
            per_page: 20,
            ...params,
        }).toString();

        const fetchOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const response = await fetch(
            `${API_PRODUCTS_URL}?${queryParams}`,
            fetchOptions
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const {
            page,
            total_items,
            total_pages,
            products,
        } = await response.json();


        return {
            data: products || [],
            total: total_items,
            totalPages: total_pages,
            page: page || 1,
        }
    },
    fetchById: async (id, params = {}) => {
        const queryParams = new URLSearchParams({
            consumer_key: consumerKey,
            consumer_secret: consumerSecret,
            ...params,
        }).toString();

        const fetchOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const url = `${API_PRODUCT_URL}${id}?${queryParams}`;

        const response = await fetch(url, fetchOptions);

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const product = await response.json();

        return product;
    },
    fetchRelatedProducts: async (productId, limit = 4) => {
        const response = await fetch(
            `${API_RELATED_PRODUCTS_URL}${productId}?limit=${limit}`,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return response.json();
    },
}